import { ApiService } from "./apiService"

export const LocationService = () => {
    return{
        getAllItem:async ()=> {
            const response =  await ApiService.get('/api/items/artworks');
            return response.data;
        },
        getItemByLocation:async (id:any)=> {
            const response =  await ApiService.get(`/api/items/artworks?fields=title,location,century,description,image.id,image.width,image.height&filter[location][_eq]=${id}`);
            return response.data;
        },
        searchData:async(requestParamFilter:any)=>{
            const response =  await ApiService.get(`/api/items/locations?filter[name][_icontains]=${requestParamFilter}&fields=*,translations.*`);
            return response.data;
        }

    }
}